// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BxAl8","type":"styles_type__1w2KC","choices":"styles_choices__1WqVX"};